import { immerable } from "immer";
import { PlatformLanguageCode } from "./platform-language-code";
import { TranskodeSubtitleFormatEnum } from "./transkode-subtitle-format-enum";
import { WarningSubtitle } from "./warning";

export enum SubtitleSdhType {
  SDH = "SDH",
  SME = "SME",
}

export enum SubtitleClosedType {
  Teletext = "Teletext",
  Caption = "Caption",
}

export class SubtitleOption {
  [immerable] = true;
  language: PlatformLanguageCode | null = { id: 0, externalId: 0, value: null, label: null, rfc5646: null };
  id: number | null = 0;
  type: string | null = null;
  isSDH: boolean | null = null;
  isClosed: boolean | null = null;
  isAvailable: boolean | null = null;
  isOriginalVersion: boolean | null = null;
  contentType: string | null = null;
  contentId: number | null = 0;
  concernedAssetIds: number[] | null = [];
  warns: WarningSubtitle[] | null = null;
  sdhType: SubtitleSdhType | null = null;
  closedType: SubtitleClosedType | null = null;
  format: TranskodeSubtitleFormatEnum | null = null;
  toBeApplied: boolean | null = null; // used only in front

  constructor(init?: Partial<SubtitleOption>) {
    Object.assign(this, init);
  }
}
